import type { FC } from 'react';
import { Flex, Skeleton, SkeletonCircle, SkeletonText, useBreakpointValue } from '@chakra-ui/react';

export const TurnToSkeleton: FC = () => {
    const bigSkeleton = useBreakpointValue({ base: false, xl: true });

    if (bigSkeleton) {
        <div
            className="flex w-full flex-col gap-4 bg-white p-4 md:px-8 lg:px-10 2xl:px-16"
            data-testid="turn-to-skeleton"
        >
            <Flex gap="4" justifyContent="center">
                <Skeleton w="140px" h="22px" />
                <Skeleton w="140px" h="22px" />
            </Flex>
            <Flex gap="4">
                <Skeleton flex="1" h="150px" />
                <Skeleton flex="1" h="150px" />
                <Skeleton flex="1" h="150px" />
            </Flex>
            <Flex gap="4">
                <Flex direction="column" width="150px" gap="4">
                    <SkeletonCircle size="16" />
                    <Skeleton w="100%" h="22px" />
                </Flex>
                <SkeletonText noOfLines={5} flex="1" h="150px" maxWidth="350px" />
            </Flex>
        </div>;
    }

    return (
        <div
            className="flex w-full flex-col gap-4 bg-white p-4 md:px-8 lg:px-10 2xl:px-16"
            data-testid="turn-to-skeleton"
        >
            <Flex gap="4">
                <Skeleton w="100px" h="22px" />
                <Skeleton w="75px" h="22px" />
            </Flex>
            <Flex gap="4" justifyContent="center" alignItems="center" direction="column">
                <Skeleton w="50px" h="50px" />
                <Skeleton w="75px" h="22px" />
                <SkeletonText noOfLines={4} flex="1" h="150px" w="100%" />
            </Flex>
        </div>
    );
};
